import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Auth, API } from 'aws-amplify'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Swal from 'sweetalert2'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import _ from 'lodash'

import './Games.scss'
import { getAuth } from '../../redux/selectors/auth'
import { getLang } from '../../redux/selectors/lang'
import fishingIcon from '../../assets/games-icon/fishing.jpeg'
import slotIcon from '../../assets/games-icon/slot.jpeg'
import casinoIcon from '../../assets/games-icon/casino.jpeg'
import loadingImg from '../../assets/dong-loading/dong-loading.png'
// import { async } from 'regenerator-runtime'

const Games = () => {
  const [ipAddress, setIPAddress] = useState(false)
  const [cooldown, setCooldown] = useState(0)
  const [allProducts, setAllProducts] = useState([])
  const [filterProducts, setFilterProducts] = useState([])
  const [gamesList, setGamesList] = useState([])
  const [gameType, setGameType] = useState('fishing')
  const [providerCode, setProviderCode] = useState(false)
  const [gameCode, setGameCode] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  // const [isLoadingCover, setIsLoadingCover] = useState(false)

  const auth = useSelector(getAuth)
  const lang = useSelector(getLang)
  const language = lang.lang

  console.log(filterProducts, 'filterProducts')

  // const effect = [
  //   'fade-up',
  //   'fade-down',
  //   'fade-right',
  //   'fade-left',
  //   'zoom-in',
  //   'zoom-out',
  //   'slide-up',
  //   'flip-up',
  //   'flip-down',
  //   'flip-right',
  //   'flip-left',
  // ]

  // const randomEffect = () => {
  //   return effect[Math.floor(Math.random() * effect.length)]
  // }

  useEffect(() => {
    AOS.init({
      duration: 1000,
    })
  }, [])

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => setIPAddress(data.ip))
      .catch((error) => console.log(error))
  }, [])

  // console.log(ipAddress, 'ipAddress')

  useEffect(() => {
    API.get('lotto', '/games/products')
      .then((res) => {
        console.log(res, 'res')
        if (res.code === 0) {
          console.log(res.detail.products, 'game products')
          const data = res.detail.products
          const filterProducts = data.filter((obj) => obj.providerName !== 'Joker' && obj.providerName !== 'PG')
          const filteredArray = filterProducts
            .map((product) =>
              product.gameTypes.map((gameType) => ({ ...gameType, providerName: product.providerName }))
            )
            .flat()
          // const concatenatedArray = [].concat(...allProducts.map((obj) => obj.gameTypes))
          // console.log(concatenatedArray, 'concatenatedArray')

          const orderArray = ['slot', 'liveCasino']

          const newOrder = filteredArray.sort((a, b) => {
            const indexA = orderArray.indexOf(a.type)
            const indexB = orderArray.indexOf(b.type)
            // กำหนดเงื่อนไขในการเรียงลำดับ
            if (a.category && !b.category) {
              return -1 // เมื่อ a มี "category" แต่ b ไม่มี ให้ a ขึ้นก่อน
            } else if (!a.category && b.category) {
              return 1 // เมื่อ b มี "category" แต่ a ไม่มี ให้ b ขึ้นก่อน
            } else {
              // เมื่อทั้ง a และ b มี "category" หรือไม่มีทั้งคู่ ให้เรียงตาม "type"
              if (indexB > indexA) return -1
              if (indexA > indexB) return 1
              return 0
            }
          })

          console.log(newOrder, 'newOrder')

          // เรียงลำดับตามเงื่อนไข
          const sortedArray = newOrder.sort((a, b) => {
            // นำ "new" ไปด้านหน้า
            if (a.name === 'PG Slots' && b.name !== 'PG Slots') {
              return -1
            }
            if (a.name !== 'PG Slots' && b.name === 'PG Slots') {
              return 1
            }

            // กรณีทั่วไป เรียงตามราคาหรือเงื่อนไขอื่น ๆ
            return a.price - b.price
          })

          setAllProducts(sortedArray)
        }
      })
      .catch((err) => {
        console.log('error fetching product ======')
        console.error(err)
      })
      .finally(() => {
        // setIsTransfer(false)
        // fetchAffiliateWallet()
      })
  }, [])

  const pickProvider = async (provider) => {
    console.log(provider, 'provider')
    setGamesList([])
    const storeProductCode = provider.provider
    const storeCode = provider.code
    setGameCode(storeCode)
    setProviderCode(storeProductCode)
    setIsLoading(true)
    await API.post('lotto', '/games/list', { body: provider })
      .then((res) => {
        console.log(res, 'res')
        if (res.code === 0) {
          console.log(res.detail.products, 'game list')
          const listGame = res.detail.products.filter((obj) => obj.code !== 'FH:YL:YL-FISH-001')

          console.log(gameType, 'gameType')
          console.log(listGame, 'listGame')
          const filterGames = listGame.filter((obj) => (obj.category = gameType))
          const sortFilterGames = filterGames.reverse()
          setGamesList(sortFilterGames)
        }
      })
      .catch((err) => {
        console.log('error fetching game ======')
        console.error(err)
      })
      .finally(() => {
        setIsLoading(false)
        // setIsTransfer(false)
        // fetchAffiliateWallet()
      })
  }

  const getHtmlGame = async (htmlUrl) => {
    if (auth.username && providerCode) {
      const playerUsername = auth.username
      await API.post('lotto', '/games/html', { body: { htmlContent: htmlUrl, username: playerUsername } })
        .then((res) => {
          console.log(res, 'res')
          if (res.code === 0) {
            console.log(res.detail, 'html game')
            const htmlLink = res.detail
            return htmlLink
          }
        })
        .catch((err) => {
          console.log('error get html game ======')
          console.error(err)
        })
        .finally(() => {
          // setIsTransfer(false)
          // fetchAffiliateWallet()
        })
      return null
    } else {
      Swal.fire({
        icon: 'error',
        // title: 'เกิดข้อผิดพลาด',
        title: language !== 'TH' ? 'အမှားအတည်ပညာ' : 'เกิดข้อผิดพลาด',
        text: 'Please Login',
      })
      // setIsLoadingCover(false)
    }
  }

  const loginToGame = async (loginGameCode, icon, name, loginProviderName) => {
    // const loginToGame = async (loginGameCode, gameIcon, gameName) => {
    console.log(loginProviderName)
    console.log(icon, name)
    setCooldown(1)
    setTimeout(() => {
      setCooldown(0)
    }, 2000)
    let gameIpAddress = '1.1.1.1'
    if (ipAddress) {
      gameIpAddress = ipAddress
    }
    // setIsLoadingCover(true)
    if (auth.username && (providerCode || loginProviderName)) {
      const langToShow = language !== 'TH' ? 'my' : 'th'
      const loginData = {
        username: auth.username,
        accountName: auth.username,
        productCode: loginProviderName ? loginProviderName : providerCode,
        gameCode: loginGameCode ? loginGameCode : '',
        language: langToShow,
        // ip: '1.1.1.1',
        ip: gameIpAddress,
      }
      // console.log(loginData, 'loginData')
      await API.post('lotto', '/games/login', { body: loginData })
        .then((res) => {
          console.log(res, 'res')
          if (res.code === 0) {
            console.log(res.detail, 'login game')
            const gameInfo = res.detail

            console.log(gameInfo, 'gameInfo')
            if (gameInfo.web) {
              // setIsLoadingCover(false)
              if (gameInfo.web.launchingUrl) {
                // window.location.href = gameInfo.web.launchingUrl
                window.open(gameInfo.web.launchingUrl, '_blank')
                // Swal.fire({
                //   icon: 'error',
                //   // title: 'เกิดข้อผิดพลาด',
                //   title: language !== 'TH' ? 'Closed for maintenance' : 'เกมอยู่ระหว่างปิดปรับปรุง',
                // })
              }
              // if (gameInfo.web.launchingUrlHTML) {
              //   const launchingUrlHTML = gameInfo.web.launchingUrlHTML
              //   // console.log(launchingUrlHTML)
              //   const getHtmlGameUrl = getHtmlGame(launchingUrlHTML)
              //   if (getHtmlGameUrl) {
              //     console.log(getHtmlGameUrl, 'getHtmlGameUrl')
              //   }
              // }
              //Swal PLAY or DEMO
              // const noDemo = !gameInfo.demo
              // if (noDemo) {
              //   Swal.fire({
              //     imageUrl: gameIcon,
              //     title: gameName,
              //     confirmButtonColor: '#7dc351',
              //     confirmButtonText: 'PLAY',
              //   }).then((result) => {
              //     if (result.isConfirmed) {
              //       window.open(gameInfo.web.launchingUrl)
              //     }
              //   })
              // } else {
              //   Swal.fire({
              //     imageUrl: gameIcon,
              //     title: gameName,
              //     confirmButtonColor: '#7dc351',
              //     confirmButtonText: 'PLAY',
              //     showDenyButton: true,
              //     denyButtonColor: '#C0C0C0',
              //     denyButtonText: 'DEMO',
              //   }).then((result) => {
              //     if (result.isConfirmed) {
              //       window.open(gameInfo.web.launchingUrl)
              //     }
              //     if (result.isDenied) {
              //       window.open(gameInfo.demo.url)
              //     }
              //   })
              // }
            } else {
              Swal.fire({
                icon: 'error',
                // title: 'เกิดข้อผิดพลาด',
                title: language !== 'TH' ? 'အမှားအတည်ပညာ' : 'เกิดข้อผิดพลาด',
              })
              // setIsLoadingCover(false)
            }
            // setGamesList(listGame)
          }
        })
        .catch((err) => {
          console.log('error fetching game ======')
          console.error(err)
          Swal.fire({
            icon: 'error',
            // title: 'เกิดข้อผิดพลาด',
            title: language !== 'TH' ? 'အမှားအတည်ပညာ' : 'เกิดข้อผิดพลาด',
            text: err,
          })
        })
        .finally(() => {
          // setIsLoadingCover(false)
          // setIsTransfer(false)
          // fetchAffiliateWallet()
        })
    } else {
      Swal.fire({
        icon: 'error',
        // title: 'เกิดข้อผิดพลาด',
        title: language !== 'TH' ? 'အမှားအတည်ပညာ' : 'เกิดข้อผิดพลาด',
        text: 'Please Login',
      })
      // setIsLoadingCover(false)
    }
  }

  console.log(providerCode, 'asdfasdf')

  return (
    <section className='deposit deposit__container mt-20 mb-20'>
      {/* SECTION 1: Game ICON */}
      <div className='games__lucky-icon'>
        <div
          className='games__lucky-icon-wrapper'
          onClick={() => {
            setGamesList([])
            setGameType('fishing')
            setFilterProducts(allProducts.filter((obj) => obj.category && obj.category === 'fishing'))
          }}
        >
          <img className='games__lucky-icon-wrapper-image' src={fishingIcon} alt='fishing-icon' />
          <div className='games__lucky-icon-wrapper-label'>
            {/* <span>ศรัทธาพารวย</span> */}
            {/* <span>{language === 'MM' ? 'ယုံကြည်ပြီး' : HOME_PAGE['ယုံကြည်ပြီး']}</span> */}
            <span>{language === 'MM' ? 'Fishing' : 'ยิงปลา'}</span>
          </div>
        </div>
        <div
          className='games__lucky-icon-wrapper'
          onClick={() => {
            setGamesList([])
            setGameType('slot')
            setFilterProducts(allProducts.filter((obj) => obj.type === 'slot' && !obj.category))
          }}
        >
          <img
            className='games__lucky-icon-wrapper-image'
            src={slotIcon}
            style={{ transform: 'translateY(15px)' }}
            alt='slot-icon'
          />
          <div className='games__lucky-icon-wrapper-label'>
            {/* <span>ผลหวยสด</span> */}
            {/* <span>{language === 'MM' ? 'တိုက်ရိုက်ထီရလဒ်' : HOME_PAGE['တိုက်ရိုက်ထီရလဒ်']}</span> */}
            <span>
              <span>{language === 'MM' ? 'Slot' : 'สล็อต'}</span>
            </span>
          </div>
        </div>
        <div
          className='games__lucky-icon-wrapper'
          onClick={() => {
            setGamesList([])
            setGameType('liveCasino')
            setFilterProducts(allProducts.filter((obj) => obj.type === 'liveCasino' && !obj.category))
          }}
        >
          <img
            className='games__lucky-icon-wrapper-image'
            src={casinoIcon}
            style={{ transform: 'translateY(15px)' }}
            alt='table-icon'
          />
          <div className='games__lucky-icon-wrapper-label'>
            <span>{language === 'MM' ? 'Casino' : 'คาสิโน'}</span>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div className='loading-gif'>
          <img className='loading-indicator-gif ' src={loadingImg} alt='loading' />
        </div>
      ) : (
        <div className={`games-${gamesList.length > 0 ? 'gameWrap' : 'productWrap'}`}>
          {gamesList.length > 0
            ? gamesList.map((item, index) => {
                const { name, icon, code } = item
                return (
                  <div
                    key={index}
                    data-aos='fade-up'
                    className={`games-gameWrap-wrapper ${gameCode === 'SLOT:PG' ? 'h-56' : ''}`}
                    // data-aos={randomEffect()}
                    // data-aos-delay={index * 10}
                  >
                    <div
                      className={`games-gameWrap-wrapper-content ${cooldown > 0 ? 'disabled' : ''} `}
                      onClick={() => loginToGame(code, icon, name)}
                    >
                      <img src={icon} alt='game icon' />
                      <h3>
                        <span className='content-title ml-2 mt-4'>{name}</span>
                      </h3>
                    </div>
                  </div>
                )
              })
            : filterProducts.length > 0
            ? filterProducts.map((item, index) => {
                const { name, icon, providerName, code } = item
                return (
                  <div key={index}>
                    <div className='tab-content' onClick={gameType === 'liveCasino' ? () => {loginToGame(code ? code : '', icon, name, providerName); } : () => pickProvider({ provider: providerName, code: code ? code : '' })}>
                      <img src={icon} alt='game icon' />
                      <h3>
                        <span className='content-title ml-2 mt-4'>{name}</span>
                      </h3>
                    </div>
                  </div>
                )
              })
            : allProducts.map((item, index) => {
                const { name, icon, providerName, code } = item

                return (
                  <div key={index} data-aos='fade-right'>
                    {/* <a
                      href='https://web.facebook.com/profile.php?id=100091981551707'
                      target='_blank'
                      rel='noopener noreferrer'
                    > */}
                    <div className='tab-content' onClick={() => pickProvider({ provider: providerName, code: code ? code : '' })}>
                      <img src={icon} alt='game icon' />
                      <h3>
                        <span className='content-titl ml-2 mt-4'>{name}</span>
                      </h3>
                    </div>
                    {/* </a> */}
                  </div>
                )
              })}
        </div>
      )}
      {/* {isLoadingCover ? (
        <div className='loading-gif'>
          <img className='loading-indicator-gif' src={loadingImg} alt='loading' />
        </div>
      ) : null} */}
    </section>
  )
}

export default Games
